// extracted by mini-css-extract-plugin
export default {"purchaseButton":"purchase_purchaseButton__L3vkw","gradient":"purchase_gradient__oGN7I"};